import React from 'react';
import { format, isSameMonth, isSameYear, parseISO } from 'date-fns';
import { fullImage, imgUrl } from '../../utils/images';
import { TripResponse } from '../../store/backendApi';

export interface TripHeaderProps {
  tripData?: TripResponse;
  username?: string;
  userId?: string;
}

export const EditTripHeader = (props: TripHeaderProps) => {
  const tripData = props.tripData;
  const dateRangeString = (startString: string, endString: string): string => {
    const startDate = parseISO(startString);
    const endDate = parseISO(endString);
    if (isSameYear(startDate, endDate)) {
      if (isSameMonth(startDate, endDate)) {
        return `${format(startDate, 'd.')} - ${format(endDate, 'd. MMMM yyyy')}`;
      }
      return `${format(startDate, 'd. MMMM')} - ${format(endDate, 'd. MMMM yyyy')}`;
    }
    return `${format(startDate, 'd. MMMM yyyy')} - ${format(endDate, 'd. MMMM yyyy')}`;
  };

  const headerUrl = tripData
    ? tripData.headerFileName
      ? imgUrl(tripData.id, fullImage(tripData.headerFileName))
      : '/default-trip-header.jpg'
    : undefined;

  return (
    <div
      className="jumbotron header-image"
      style={{
        backgroundImage: `url("${headerUrl}")`,
      }}
    >
      <div className="header-info flex flex-col justify-between">
        <div>
          {tripData && tripData.startDate && tripData.endDate && (
            <p id="date-range">{dateRangeString(tripData.startDate, tripData.endDate)}</p>
          )}
          <h1>{tripData?.title ?? ''}</h1>
          {tripData && (
            <div className="relative w-full flex justify-center mt-6">
              <div className="absolute top-1/2 left-[10%] w-[80%] h-px bg-gray-300" />
              <a href={`/profile/${tripData.ownerId}`} className="inline-block size-12 z-1">
                {tripData && tripData.ownerId && (
                  <img
                    title={'profile'}
                    src={`https://media.${process.env.REACT_APP_HOST}/users/${
                      tripData.ownerId
                    }-thumbnail.jpg?v=${Date.now()}`}
                    className="rounded-full w-full h-full border-2 border-white object-cover"
                    onError={(e) => (e.currentTarget.src = '/default-profile-picture.jpg')}
                  />
                )}
              </a>
            </div>
          )}
          <div className="header-info-etails">{tripData?.description ?? ''}</div>
        </div>
      </div>
    </div>
  );
};
